import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <p className="text-muted footer-text">
            ©2017 San Joaquin Delta College
          </p>
        </div>
      </footer>
    );
  }
}

export default Footer;